import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// import Cookies from 'js-cookie'
import AuthModule from '~/repository/modules/auth';
import ComponentDataModule from '~/repository/modules/component-data';
import ExternalModule from '~/repository/modules/external';
import FormDataModule from '~/repository/modules/form-data';
import AlertConfigurationModule from '~/repository/modules/alert-configuration';
import SettingsModule from '~/repository/modules/settings';
import ScreeningsModule from '~/repository/modules/screenings';
import ScreeningOrderModule from '~/repository/modules/screening-order';
import ContactModule from '~/repository/modules/contact';
import TransactionsModule from '~/repository/modules/transactions';
import CommentsModule from '~/repository/modules/comments';
import PackagesModule from '~/repository/modules/packages';
import OnboardingModule from '~/repository/modules/onboarding';
import InvoicesModule from '~/repository/modules/invoices';
import ScreeningStepsModule from '~/repository/modules/screening-steps';
import ScreeningAnswersMobule from '~/repository/modules/screening-answers';
import DocumentsModule from '~/repository/modules/documents';
import UserInfoModule from '~/repository/modules/user-info';
import ClientModule from '~/repository/modules/client';
import BillingModule from '~/repository/modules/billing';
import AddressesModule from '~/repository/modules/addresses';
import HttpFactory from '~/repository/factory';
import DashboardModule from '~/repository/modules/dashboard';
import StateOfService from '~/repository/modules/state-of-service';
import SubscriptionsModule from '~/repository/modules/subscriptions';
import MarketplaceModule from '~/repository/modules/marketplace';
import MarketplaceExternal from '~/repository/modules/marketplace-external';
import InputSearcherModule from '~/repository/modules/input-searcher';
import DASignerModule from '~~/repository/modules/da-signer';
import ReleaseNoteModule from '~/repository/modules/release-notes';
import RatingModule from "~/repository/modules/rating";
import IntegrationsModule from '~/repository/modules/integrations';
import IDValidatorModule from '~/repository/modules/id-validator';
import CustomPDFModule from '~/repository/modules/custom-pdf';
import { useNuxtApp } from '#app';

// eslint-disable-next-line no-undef
export default defineNuxtPlugin(function (_ref) {
  var _route$query;
  var $config = _ref.$config,
    _ref$nuxt2Context = _ref.nuxt2Context,
    route = _ref$nuxt2Context.route,
    store = _ref$nuxt2Context.store;
  var baseApi = $config.public.baseApi;
  var accessToken = (route === null || route === void 0 ? void 0 : (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.token) || localStorage.getItem("external.token") || null;
  var fetchBaseOptions = {
    baseURL: baseApi
  };
  var fetchOptionsSocial = _objectSpread(_objectSpread({}, fetchBaseOptions), {}, {
    headers: {
      Accept: "application/json"
    },
    // eslint-disable-next-line require-await
    onRequest: function onRequest(config) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var $auth, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              $auth = useNuxtApp().nuxt2Context.$auth;
              if (!$auth.check(true).tokenExpired) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return $auth.refreshTokens();
            case 4:
              token = $auth.strategy.token.get();
              config.options.headers = _objectSpread(_objectSpread({}, config.options.headers), {}, {
                Authorization: "".concat(token)
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onResponse: function onResponse(data) {
      var askRatingHeader = data.response.headers.get("ask-rating");
      if (askRatingHeader) {
        var value = askRatingHeader.toLowerCase() === "true";
        store.dispatch("setAskRating", {
          value: value
        });
      }
    }
  });
  var fetchOptionsToken = _objectSpread(_objectSpread({}, fetchBaseOptions), {}, {
    // credentials: `include`,
    headers: {
      Authorization: "Token ".concat(accessToken)
    }
  });

  /** create a new instance of $fetcher with custom option */
  // eslint-disable-next-line no-undef
  var apiFetcherWithSocial = $fetch.create(fetchOptionsSocial);
  // eslint-disable-next-line no-undef
  var apiFetcherWithToken = $fetch.create(fetchOptionsToken);
  // eslint-disable-next-line no-undef
  var apiFetcher = $fetch.create(fetchBaseOptions);

  /** an object containing all repositories we need to expose */
  var modules = {
    addresses: new AddressesModule(apiFetcherWithSocial),
    auth: new AuthModule(apiFetcherWithSocial),
    alertConfiguration: new AlertConfigurationModule(apiFetcherWithSocial),
    billing: new BillingModule(apiFetcherWithSocial),
    client: new ClientModule(apiFetcherWithSocial),
    contact: new ContactModule(apiFetcherWithSocial),
    comments: new CommentsModule(apiFetcherWithSocial),
    componentData: new ComponentDataModule(apiFetcherWithSocial),
    dashboard: new DashboardModule(apiFetcherWithSocial),
    documents: new DocumentsModule(apiFetcherWithSocial),
    documentsExternal: new DocumentsModule(apiFetcherWithToken),
    external: new ExternalModule(apiFetcherWithToken),
    formData: new FormDataModule(apiFetcherWithSocial),
    invoices: new InvoicesModule(apiFetcherWithSocial),
    onboarding: new OnboardingModule(apiFetcher),
    packages: new PackagesModule(apiFetcherWithSocial),
    screenings: new ScreeningsModule(apiFetcherWithSocial),
    screeningSteps: new ScreeningStepsModule(apiFetcherWithSocial),
    screeningOrder: new ScreeningOrderModule(apiFetcherWithSocial),
    screeningAnswers: new ScreeningAnswersMobule(apiFetcherWithSocial),
    settings: new SettingsModule(apiFetcherWithSocial),
    transactions: new TransactionsModule(apiFetcherWithSocial),
    userInfo: new UserInfoModule(apiFetcherWithSocial),
    request: new HttpFactory(apiFetcherWithSocial),
    stateOfService: new StateOfService(apiFetcherWithSocial),
    subscriptions: new SubscriptionsModule(apiFetcherWithSocial),
    marketplace: new MarketplaceModule(apiFetcherWithSocial),
    marketplaceExternal: new MarketplaceExternal(apiFetcherWithToken),
    inputSearcher: new InputSearcherModule(apiFetcherWithSocial),
    inputSearcherExternal: new InputSearcherModule(apiFetcherWithToken),
    daSigner: new DASignerModule(apiFetcherWithSocial),
    daSignerExternal: new DASignerModule(apiFetcherWithToken),
    releaseNotes: new ReleaseNoteModule(apiFetcherWithSocial),
    rating: new RatingModule(apiFetcherWithSocial),
    integrations: new IntegrationsModule(apiFetcherWithSocial),
    idValidator: new IDValidatorModule(apiFetcherWithSocial),
    customPDF: new CustomPDFModule(apiFetcherWithSocial)
  };

  // nuxtApp.provide(`api`, () => modules)
  return {
    provide: {
      api: modules
    }
  };
});